import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import _ from 'lodash';

import { makeCanonicalTagObj, makeHreflangTagArr } from '@/utils';
import QuickLinksSection from '../../components/QuickLinksSection';
import Placeholder from '../../components/Placeholder';
import BreadCrumbMenu from '../../components/BreadCrumbMenus/';
import { TABLET_P } from '../../constants';

import Instructors from './Instructors/Instructors';
import SeminarsList from './SeminarsList/SeminarsList';
import SeminarScheduleHero from './SeminarScheduleHero/SeminarScheduleHero';
import Application from './Application/Application';
import ContactUs from './ContactUs/ContactUs';
import Place from './Place/Place';

const Wrapper = styled.div``;

const keyToId = {
  seminarsQuickLinkLabel: 'seminars-section',
  instructorsQuickLinkLabel: 'instructors-section',
  applicationQuickLinkLabel: 'application-section',
  contactUsQuickLinkLabel: 'contactUs-section',
  placeQuickLinkLabel: 'place-section',
};

/**
 * 「セミナー」画面 > 「セミナーのご案内」画面
 */
const SeminarSchedulePage = ({ data, locale, menuInfo }) => {
  const links = [];
  Object.keys(keyToId).forEach(key => {
    if (data[key]) {
      links.push({ id: keyToId[key], label: data[key] });
    }
  });
  return (
    <Wrapper>
      {_.get(data, 'metaData') && (
        <Helmet
          title={_.get(data.metaData, 'title')}
          link={[
            makeCanonicalTagObj(locale, '/seminar-schedule'),
            ...makeHreflangTagArr(data.metaData.region, '/seminar-schedule'),
          ]}
          meta={[
            {
              name: 'description',
              content: _.get(data.metaData, 'description'),
            },
            {
              name: 'keyword',
              content: _.get(data.metaData, 'keyword'),
            },
            // TODO: OGP タグは一旦保留 (2020年01月07日)
            // {
            //   property: 'og:url',
            //   content: _.get(data.metaData, 'url'),
            // },
            // {
            //   property: 'og:type',
            //   content: _.get(data.metaData, 'type'),
            // },
            // {
            //   property: 'og:title',
            //   content: _.get(data.metaData, 'title'),
            // },
            // {
            //   property: 'og:image',
            //   content: _.get(data.metaData, 'image.file.url'),
            // },
            // {
            //   property: 'og:description',
            //   content: _.get(data.metaData, 'description'),
            // },
            // {
            //   property: 'og:site_name',
            //   content: _.get(data.metaData, 'siteName'),
            // },
          ]}
        />
      )}
      <SeminarScheduleHero data={data} />
      {links.length > 0 && <QuickLinksSection links={links} />}
      <SeminarsList copy={data.copy} />
      {!(data && _.get(data, 'seminarsQuickLinkLabel')) ? (
        <Placeholder
          w={window.innerWidth > TABLET_P ? 'calc(100% - 240px)' : '100%'}
          h="362px"
          m="0 120px 60px 120px"
        />
      ) : (
        <Instructors
          copy={data.copy}
          instructors={data.instructors}
          region={data.region}
          locale={locale}
          ancestor={data.seminarsQuickLinkLabel.toUpperCase()}
        />
      )}
      <Application app={data && data.applications} />
      <ContactUs contactUs={data && data.contactUs} />
      <Place place={data && data.place} />
      {!(locale && menuInfo && _.get(menuInfo, 'label') && data && _.get(data, 'seminarsQuickLinkLabel')) ? (
        <Placeholder w="200px" h="24px" m={window.innerWidth > TABLET_P ? '0 0 20px 40px' : '0 0 20px 20px'} />
      ) : (
        <BreadCrumbMenu
          currentPath={`https://www.shiseido-professional.com/${locale}/seminar-schedule`}
          items={[
            {
              name: 'TOP',
              path: `/${locale}/`,
            },
            {
              name: menuInfo.label,
              path: `/${locale}/education`,
            },
            {
              name: data.seminarsQuickLinkLabel.toUpperCase(),
              path: null,
            },
          ]}
        />
      )}
    </Wrapper>
  );
};

SeminarSchedulePage.defaultProps = {
  data: {
    copy: {},
  },
  locale: null,
};

SeminarSchedulePage.propTypes = {
  // セミナーメニュー情報 (パンくずリストに必要な情報を含む)
  menuInfo: PropTypes.shape({}).isRequired,
  data: PropTypes.shape(),
  locale: PropTypes.string,
};

const mapState = state => ({
  // セミナーメニュー情報をキャッシュしておく
  menuInfo: state.siteOptions.menu ? state.siteOptions.menu[4] : {},
  locale: state.locale,
});

export default connect(mapState)(SeminarSchedulePage);



// WEBPACK FOOTER //
// ./src/pages/SeminarSchedulePage/SeminarSchedulePage.js